export default function SectionButton({ slot, icon, active, setSection, children }) {
    const onClick = () => {
        setSection(slot);
    };

    return (
        <li data-slot={slot} className={active?'active':''} onClick={onClick}>
            <div className='icon'></div>
        </li>
    )
}
